import { SlidersHorizontal } from "lucide-react";

/** Shared empty when list search has no matches. */
export function NotificationSearchEmpty({
  caption,
  onClearSearch,
}: {
  caption: string;
  onClearSearch: () => void;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center px-6 py-14">
      <div className="mb-5 flex size-12 items-center justify-center rounded-xl bg-muted/80 ring-1 ring-inset ring-border/50">
        <SlidersHorizontal className="size-5 text-muted-foreground" aria-hidden />
      </div>
      <p className="text-sm font-normal text-foreground">No results for this search</p>
      <p className="mt-1 max-w-[20rem] text-center text-sm font-normal leading-relaxed text-muted-foreground">
        {caption}
      </p>
      <button
        type="button"
        onClick={onClearSearch}
        className="mt-4 rounded-full bg-foreground/10 px-4 py-1.5 text-xs font-medium text-foreground/80 transition-colors duration-150 hover:bg-foreground/15"
      >
        Clear search
      </button>
    </div>
  );
}
